import { getParentSaleLines } from '@/components/pos/posCart'
import { saleMeetsGuestRequirement } from '@/components/pos/posCustomer'

/**
 * @param {import('@/types/api').Sale | null | undefined} sale
 */
export function canHoldSaleLines(sale) {
  if (!sale || sale.status !== 'draft') return false
  return getParentSaleLines(sale).length > 0
}

/**
 * @param {import('@/types/api').Sale | null | undefined} sale
 */
export function canHoldSale(sale) {
  if (!canHoldSaleLines(sale)) return false
  return saleMeetsGuestRequirement(sale)
}

/**
 * @param {import('@/types/api').SuspendedSaleSummary} summary
 */
export function formatSuspendedGuestLabel(summary) {
  if (summary.customer?.name) {
    return summary.customer.name
  }
  return 'Walk-in'
}

/**
 * @param {import('@/types/api').SuspendedSaleSummary} summary
 */
export function formatSuspendedTotal(summary) {
  const total = Number(summary.total)
  if (!Number.isFinite(total)) return 'AED 0.00'
  return `AED ${total.toFixed(2)}`
}

/**
 * @param {string | null | undefined} iso
 */
export function formatSuspendedAt(iso) {
  if (!iso) return 'Held'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return 'Held'
  return date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })
}

/**
 * @param {import('@/types/api').SuspendedSaleSummary} summary
 */
export function formatSuspendedTicketLabel(summary) {
  const guest = formatSuspendedGuestLabel(summary)
  const services = summary.lines_count === 1 ? '1 service' : `${summary.lines_count} services`
  return `${summary.sale_number} · ${guest} · ${services}`
}
